import { render, staticRenderFns } from "./ShiftVDPIngredients.vue?vue&type=template&id=9cc53f6e&"
import script from "./ShiftVDPIngredients.vue?vue&type=script&lang=ts&"
export * from "./ShiftVDPIngredients.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftVDPIngredients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports